import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { ErrorBoundary } from '@sentry/react';
import { SnackbarProvider } from 'notistack';
import React from 'react';

import { Provider } from 'react-redux';

import { ApiContext, ApiResources } from '_lib/api/apiContext';
import { QueryProvider } from '_lib/api/QueryProvider';

import { AuthContext, AuthResources } from '_lib/featureComponents/auth/authContext';

import { store } from '_lib/redux/store';
import { theme } from '_lib/styles/theme';

import { CallPilotRouterProvider } from './CallPilotRouterProvider';

// Set the document title for the entire app (not needed in component scope)
document.title = 'Relate CX';

export const CallPilotApp = (): React.ReactElement => {
  return (
    <>
      <CssBaseline />
      {/** Wrap entire application with redux store context. */}
      <Provider store={store}>
        <QueryProvider devToolProps={[{ initialIsOpen: false }]}>
          <AuthContext value={AuthResources}>
            <ApiContext value={ApiResources}>
              <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                  <SnackbarProvider preventDuplicate anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                    <ErrorBoundary
                      beforeCapture={(scope) => scope.setTag('pane', 'Call Pilot App Root')}
                      fallback={<p>An unexpected error has occurred. Please refresh the page.</p>}>
                      {CallPilotRouterProvider({ AuthResources })}
                    </ErrorBoundary>
                  </SnackbarProvider>
                </LocalizationProvider>
              </ThemeProvider>
            </ApiContext>
          </AuthContext>
        </QueryProvider>
      </Provider>
    </>
  );
};
